import {call, put, takeLatest} from "redux-saga/effects";
import Api from "../services/api";
import {checkUserHelper} from "../services/api-util";
import {
    doneCreateResourceDiff,
    doneDeleteResourceDiff,
    doneGetResourceDiff,
    doneUpdateResourceDiff,
    errorCreateResourceDiff,
    errorDeleteResourceDiff,
    errorGetResourceDiff,
    errorUpdateResourceDiff
} from "../actions/resourceDiff";
import {pushNotification} from "../actions/ui";
import {getErrorNotificationWithExceptions} from "../../common/util/util-helpers";

export function* createResourceDiffCall(action) {
    const user = yield* checkUserHelper(action.data.user);
    let result;
    if (action.data.request === 'PUT') {
        result = yield call(Api.putResource, user, action.data.params, action.data.resource);
    } else {
        result = yield call(Api.createResource, user, action.data.params, action.data.resource);
    }

    if (result && result.status === 0) {
        if (action.data.showRedirectDialog) {
            result.data.showRedirectDialog = action.data.showRedirectDialog
        } else {
            result.data.showRedirectDialog = false;
        }

        if (action.data.file && action.data.file.length > 1) {
            const id = getIdForImageResource(action, result);
            yield call(
                Api.uploadFiles,
                user,
                action.data.fileResource ? action.data.fileResource : action.data.resource,
                action.data.file,
                Object.assign(action.data.fileParams
                        ? action.data.fileParams
                        : action.data.params,
                    action.data.customID
                        ? {[action.data.customID]: id}
                        : {id: id}),
                {},
                action.data.customID);
        } else if (action.data.file && action.data.file[0]) {
            const id = getIdForImageResource(action, result);
            yield call(Api.uploadFile, user,
                action.data.fileResource ? action.data.fileResource : action.data.resource,
                action.data.file[0],
                Object.assign(action.data.fileParams ? action.data.fileParams : action.data.params, action.data.customID ? {[action.data.customID]: id} : {id: id}))
        }

        if (action.data.document && action.data.document.length > 1) {
            const id = getIdForDocumentResource(action, result);
            yield call(Api.uploadDocuments,
                user,
                id,
                action.data.document,
                null,
                null,
                action.data.documentResource ? action.data.documentResource : action.data.resource,
                null,
                action.data.customID
            );
        } else if (action.data.document && action.data.document[0]) {
            const id = getIdForDocumentResource(action, result);
            yield call(Api.uploadDocument,
                user,
                null,
                action.data.document[0],
                null,
                action.data.documentResource ? action.data.documentResource : action.data.resource,
                id,
                action.data.customID
            );
        }

        if (action.data.piggyResource) {
            const resPiggy = yield call(Api.getResource, user, action.data.piggyQuery ?? action.data.query, action.data.piggyResource);
            if (action.data.onPiggyCallback && resPiggy) {
                action.data.onPiggyCallback(resPiggy)
            }
            if (resPiggy && resPiggy.status === 0) {
                yield put(doneGetResourceDiff(resPiggy.data));
                yield put(doneCreateResourceDiff(result.data));
            }
        } else {
            yield put(doneCreateResourceDiff(result.data));
        }

        if (action.data.successMessage) {
            yield put(pushNotification({
                title: action.data.successMessage === true ? result.data : action.data.successMessage,
                timeout: action.data.timeout ?? true
            }));
        }
    } else {
        yield put(errorCreateResourceDiff(result.data));

        if (action.data.errorMessage) {
            yield put(pushNotification(getErrorNotificationWithExceptions(result, action)));
        }
    }
}

export function* watchCreateResourceDiff() {
    yield takeLatest('CREATE_RESOURCE_DIFF', createResourceDiffCall);
}

export function* watchCreateResourceDiffSilent() {
    yield takeLatest('CREATE_RESOURCE_DIFF_SILENT', createResourceDiffCall);
}

export function* getResourceDiffCall(action) {
    let user = null;
    if (action.data.user) {
        user = yield* checkUserHelper(action.data.user);
    }

    let result = yield call(Api.getResource, user, action.data.query, action.data.resource);

    if (result && result.status === 0) {
        yield put(doneGetResourceDiff(result.data));
    } else {
        yield put(errorGetResourceDiff(result));
        if (action.data.errorMessage) {
            yield put(pushNotification(getErrorNotificationWithExceptions(result, action)));
        }
    }
}

export function* watchGetResourceDiff() {
    yield takeLatest('GET_RESOURCE_DIFF', getResourceDiffCall);
}

export function* updateResourceDiffCall(action) {
    const user = yield* checkUserHelper(action.data.user);

    const result = yield call(Api.updateResource, user, action.data.params, action.data.resource);
    if (result && result.status === 0) {
        if (action.data.file && action.data.file.length > 1) {
            yield call(Api.uploadFiles,
                user,
                action.data.fileResource ? action.data.fileResource : action.data.resource,
                action.data.file,
                Object.assign(action.data.fileParams ? action.data.fileParams : action.data.params, {id: result.data.id}));
        } else if (action.data.file && action.data.file[0]) {
            yield call(Api.uploadFile, user,
                action.data.fileResource ? action.data.fileResource : action.data.resource,
                action.data.file[0],
                action.data.fileParams ? action.data.fileParams : action.data.params);
        }

        if (action.data.piggyResource) {
            const resPiggy = yield call(Api.getResource, user, action.data.query, action.data.piggyResource);
            if (resPiggy && resPiggy.status === 0) {
                yield put(doneGetResourceDiff(resPiggy.data));
                yield put(doneUpdateResourceDiff(result.data));
            }
        } else {
            yield put(doneUpdateResourceDiff(result.data));
        }

        if (action.data.successMessage) {
            yield put(pushNotification({
                title: action.data.successMessage === true ? result.data : action.data.successMessage,
                timeout: action.data.timeout ?? true
            }));
        }
    } else {
        yield put(errorUpdateResourceDiff(result.data));

        if (action.data.errorMessage) {
            yield put(pushNotification(getErrorNotificationWithExceptions(result, action)));
        }
    }
}

export function* watchUpdateResourceDiff() {
    yield takeLatest('UPDATE_RESOURCE_DIFF', updateResourceDiffCall);
}

export function* watchUpdateResourceDiffSilent() {
    yield takeLatest('UPDATE_RESOURCE_DIFF_SILENT', updateResourceDiffCall);
}

export function* deleteResourceDiffCall(action) {
    const user = yield* checkUserHelper(action.data.user);

    const result = yield call(Api.deleteResource, user, action.data.query, action.data.resource);
    if (result && result.status === 0) {
        if (action.data.piggyResource) {
            const resPiggy = yield call(Api.getResource, user, action.data.piggyQuery ?? action.data.query, action.data.piggyResource);
            if (action.data.onPiggyCallback && resPiggy) {
                action.data.onPiggyCallback(resPiggy)
            }
            if (resPiggy && resPiggy.status === 0) {
                yield put(doneGetResourceDiff(resPiggy.data));
                yield put(doneDeleteResourceDiff(result.data));
            }
        } else {
            yield put(doneGetResourceDiff(result.data));
        }


        if (action.data.successMessage) {
            yield put(pushNotification({
                title: action.data.successMessage === true ? result.data : action.data.successMessage,
                timeout: action.data.timeout ?? true
            }));
        }
    } else {
        yield put(errorDeleteResourceDiff(result.data));

        if (action.data.errorMessage) {
            yield put(pushNotification(getErrorNotificationWithExceptions(result, action)));
        }
    }
}

export function* watchDeleteResourceDiff() {
    yield takeLatest('DELETE_RESOURCE_DIFF', deleteResourceDiffCall);
}

export function* watchDeleteResourceDiffSilent() {
    yield takeLatest('DELETE_RESOURCE_DIFF_SILENT', deleteResourceDiffCall);
}

function getIdForImageResource(action, result) {
    let id
    if (action.data.resource === "drivers" || action.data.resource === "employees" || action.data.resource === "agents") {
        id = result.data.ContactID
    } else {
        id = result.data.id
    }
    return id;
}

function getIdForDocumentResource(action, result) {
    let id
    if (action.data.resource === "drivers") {
        id = result.data.DriverID
    } else if (action.data.resource === "carriers" || action.data.resource === "customers" || action.data.resource === "vendors") {
        id = result.data.OrganizationID
    } else if (action.data.resource === "employees") {
        id = result.data.EmployeeID
    } else {
        id = result.data.id
    }
    return id;
}